import PropTypes from "prop-types";
import { Component } from "react";
import DropDownListSearch from "../Common/Forms/DropdownListSearchable";
import FormButtonsForCloseAndSubmit from "../Common/Forms/FormButtonsForCloseAndSubmit";
import FromToDateTimePickerNative from "../Common/Forms/FromToDateTimePickerNative";
import TextInput from "../Common/Forms/TextInput";

export default class MiljogebyrFilterForm extends Component {
  static propTypes = {
    showSokSpinner: PropTypes.bool,
    InnsynMiljogebyrFilterFormState: PropTypes.object,
    handleChange: PropTypes.func,
    onSubmit: PropTypes.func,
    handleChangeToInitState: PropTypes.func,
    overtredelseskoderMiljogebyr: PropTypes.array,
  };

  getOvertredelseskoderMiljogebyr(id) {
    for (
      let index = 0;
      index < this.props.overtredelseskoderMiljogebyr.length;
      index++
    ) {
      const overtredelseskoder = this.props.overtredelseskoderMiljogebyr[index];
      if (id === overtredelseskoder.id) {
        return overtredelseskoder.paragraf;
      }
    }
  }
  render() {
    const {
      showSokSpinner,
      InnsynMiljogebyrFilterFormState,
      overtredelseskoderMiljogebyr,
      handleChange,
      handleBlur,
      onSubmit,
      handleChangeToInitState,
    } = this.props;
    return (
      <form className="SearchInnsynForm">
        <div className="SearchFilterOverskrift">Søk etter miljogebyrer</div>
        <div className="filter-flexbox-container innsyn-miljogebyrsok-filter-flexbox-item">
          <TextInput
            id="ileggelsesnummer"
            name="ileggelsesnummer"
            label="Ileggelsesnummer"
            value={InnsynMiljogebyrFilterFormState.ileggelsesnummer}
            onChange={handleChange}
            onBlur={handleBlur}
            validationError={
              InnsynMiljogebyrFilterFormState.validationError.ileggelsesnummer
            }
          />
          <FromToDateTimePickerNative
            from={{
              date: {
                id: "fraDato",
                name: "fraDato",
                label: "Dato fra",
                placeholder: "Velg",
                value: InnsynMiljogebyrFilterFormState.fraDato,
                validationError:
                  InnsynMiljogebyrFilterFormState.fraDatoValidationErrorText,
              },
              time: {
                id: "fraTid",
                name: "fraTid",
                label: "Tid fra",
                placeholder: "Velg",
                value: InnsynMiljogebyrFilterFormState.fraTid,
                validationError:
                  InnsynMiljogebyrFilterFormState.fraTidValidationErrorText,
              },
            }}
            to={{
              date: {
                id: "tilDato",
                name: "tilDato",
                label: "Dato til",
                placeholder: "Velg",
                value: InnsynMiljogebyrFilterFormState.tilDato,
                validationError:
                  InnsynMiljogebyrFilterFormState.tilDatoValidationErrorText,
              },
              time: {
                id: "tilTid",
                name: "tilTid",
                label: "Tid til",
                placeholder: "Velg",
                value: InnsynMiljogebyrFilterFormState.tilTid,
                validationError:
                  InnsynMiljogebyrFilterFormState.tilTidValidationErrorText,
              },
            }}
            onChange={handleChange}
          />
        </div>
        <div
          className="filter-flexbox-container innsyn-miljogebyrsok-filter-flexbox-item"
          style={{ marginTop: 15 }}
        >
          <TextInput
            id="gatenavn"
            name="gatenavn"
            label="Gatenavn/Ved"
            value={InnsynMiljogebyrFilterFormState.gatenavn}
            onChange={handleChange}
          />
          <TextInput
            id="gatenummer"
            name="gatenummer"
            label="Gatenummer/Ved nr."
            value={InnsynMiljogebyrFilterFormState.gatenummer}
            onChange={handleChange}
          />
          <DropDownListSearch
            label="Overtredelseskode"
            name="overtredelseskode"
            title={
              this.props.InnsynMiljogebyrFilterFormState.overtredelse
                ? this.getOvertredelseskoderMiljogebyr(
                    this.props.InnsynMiljogebyrFilterFormState.overtredelse,
                  )
                : "Velg"
            }
            placeholder="Søk etter kode"
            items={
              overtredelseskoderMiljogebyr &&
              [{ id: "", navn: "Velg", beskrivelse: "" }].concat(
                overtredelseskoderMiljogebyr.map((ok) => {
                  return {
                    id: ok.id,
                    navn: ok.id.toString(),
                    beskrivelse: ok.paragraf + " - " + ok.kortTekst,
                  };
                }),
              )
            }
            selected={
              this.props.InnsynMiljogebyrFilterFormState.overtredelseskode
            }
            handleChange={handleChange}
          />
        </div>
        <div style={{ marginTop: 5 }}>
          <FormButtonsForCloseAndSubmit
            closeText="Tilbakestill"
            showSubmitSpinner={showSokSpinner}
            submitText="Søk"
            onSubmit={onSubmit}
            onClose={handleChangeToInitState}
            showCloseSpinner={false}
          />
        </div>
      </form>
    );
  }
}
